import type { ModuleAccordionFieldsFragment } from "./__generated/module-accordion.contentful.generated";
import { Accordion, Grid, GridItem, Flex, Box } from "@project/ui";
import { PartAccordionItem } from "./part-accordion-item";
import { Title } from "@/components/title";
import { Description } from "@/components/description";
import { ModuleSpacer } from "@/components/module-spacer";
import { gridGap, gridTemplateColumns } from "@project/ui/src/theme/global-styles";

type AccordionProps = ModuleAccordionFieldsFragment & {
    isEmbedded?: boolean;
    moduleIndex?: number | null;
};

export const ModuleAccordion = ({
    title,
    subtitle,
    theme,
    isTitleLeftAligned,
    partAccordionItemsCollection,
    sys,
    isEmbedded,
    __typename,
    moduleIndex,
}: AccordionProps) => {
    const _theme = theme ?? "light";

    return (
        <ModuleSpacer
            bg={_theme === "light" ? "allWhite" : "porscheBlack"}
            color={_theme === "light" ? "porscheBlack" : "allWhite"}
            {...(isEmbedded && { wrapperProps: { px: 0 } })}
        >
            <Grid templateColumns={gridTemplateColumns} gap={gridGap}>
                {isTitleLeftAligned && (
                    <GridItem
                        colStart={1}
                        colEnd={{
                            base: 4,
                        }}
                        px={{ base: 5, l: 0 }}
                        pt={{ base: 5, l: 0 }}
                        pb={{ base: 2, l: 0 }}
                    >
                        <Flex direction="column">
                            {title && <Title>{title}</Title>}
                            {subtitle && <Description>{subtitle}</Description>}
                        </Flex>
                    </GridItem>
                )}
                <GridItem
                    colStart={{ base: 1, l: isTitleLeftAligned ? 4 : 1 }}
                    colEnd={{
                        base: 5,
                        l: 13,
                    }}
                >
                    {!isTitleLeftAligned && (
                        <Box mb={{ base: 6, l: 8 }}>
                            {title && <Title>{title}</Title>}
                            {subtitle && <Description>{subtitle}</Description>}
                        </Box>
                    )}
                    {partAccordionItemsCollection?.items.length && (
                        <Accordion allowMultiple={false} allowToggle>
                            {partAccordionItemsCollection.items.map(
                                (item, index) =>
                                    item?.__typename === "PartAccordionItem" && (
                                        <PartAccordionItem
                                            {...item}
                                            key={`${sys.id}-${item.sys.id}-${index}`}
                                            counter={index}
                                            theme={_theme}
                                            moduleName={__typename.toString()}
                                            modulePosition={moduleIndex}
                                        />
                                    )
                            )}
                        </Accordion>
                    )}
                </GridItem>
            </Grid>
        </ModuleSpacer>
    );
};
